module.exports = __webpack_public_path__ + "img/app_1.c23c9ca3.jpg";